import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, AppStoreConfigs, ConfigScopesEnum } from 'builder/modules/init'

export const useConfig = <T extends keyof AppStoreConfigs = ConfigScopesEnum.app>(
  scope?: T,
): AppStoreConfigs[T] | null => {
  return useTypedSelector(state => selectors.config(state, scope))
}
